import { lazy } from '@/service/lazy'

export default [{
  name: 'Administração de Regras',
  path: 'regras',
  id: 'regras',
  icon: 'fa fa-cog',
  component: lazy('app/default/gerenciador/regras/index'),
  meta: { requireAuth: true, rules: ['gerenciar_regra_comissionamento'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/regras.js